import { render } from "./TheHeaderMd.vue?vue&type=template&id=6189cb97"
import script from "./TheHeaderMd.vue?vue&type=script&lang=js"
export * from "./TheHeaderMd.vue?vue&type=script&lang=js"

import exportComponent from "F:\\online.ug\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__